var _circle, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCopyFull(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 18,
    fill: "#008C15"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.2 25.1999H12.7C12.1477 25.1999 11.7 24.7522 11.7 24.1999V10.8999C11.7 10.3476 12.1477 9.8999 12.7 9.8999H21.5C22.0522 9.8999 22.5 10.3476 22.5 10.8999V17.0999",
    stroke: "white",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.0999 18H19.3499V19.8H17.0999V18ZM20.2499 18H22.9499V19.8H20.2499V18ZM23.8499 18H26.0999V19.8H23.8499V18ZM17.0999 23.025V20.775H18.8999V23.025H17.0999ZM26.0999 20.775V23.025H24.2999V20.775H26.0999ZM17.0999 26.025V23.775H18.8999V26.025H17.0999ZM26.0999 23.775V26.025H24.2999V23.775H26.0999ZM17.0999 27H19.3499V28.8H17.0999V27ZM26.0999 27V28.8H23.8499V27H26.0999ZM22.9499 28.8H20.2499V27H22.9499V28.8Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyFull);
export default __webpack_public_path__ + "static/media/CopyFull.c90ce0b6e2e53098a693902909e984d9.svg";
export { ForwardRef as ReactComponent };